module.exports = __webpack_public_path__ + "fa2772327f55d8198301fdb8bcfc8158.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/glyphicons/glyphicons-webfont.woff
 ** module id = ./src/styles/fonts/glyphicons/glyphicons-webfont.woff
 ** module chunks = 0
 **/